import { useLocalStorage } from '@uidotdev/usehooks';
import { Outlet, useNavigate } from 'react-router';
import { LoginResponseData } from '@EHSNavigator/backend';
import InfoContent from './components/InfoContent';
import WarningIcon from './assets/icons/warning-icon.svg?react';

const PlatformOwnerRoute = () => {
  const navigate = useNavigate();
  const [userInfo] = useLocalStorage<LoginResponseData | null>('userInfo', null);

  if (!userInfo) {
    return null;
  }

  const isPlatformOwnerFromUser = Boolean(userInfo?.user?.isAppOwner);;
  
  const isPlatformOwnerFromPermissions = userInfo?.user?.role?.permissions?.some(
    (permission) => permission?.name === 'isPlatformOwner' || permission?.name === '/onboard-organization'
  );

  const isPlatformOwner = isPlatformOwnerFromUser || isPlatformOwnerFromPermissions || false;

  return isPlatformOwner ? (
    <Outlet />
  ) : (
    <div className="flex w-full flex-1 flex-col items-center justify-center">
      <InfoContent
        icon={<WarningIcon className="h-100 w-100 lg:h-150 lg:w-150" />}
        title="Access denied"
        description="You need to be a Platform Owner to access this page."
        buttonLabel="Go to Dashboard"
        warn
        otherClasses=""
        handleClick={() => navigate('/dashboard')}
      />
    </div>
  );
};

export default PlatformOwnerRoute;